import React, {Component} from "react";
import './verificationPopUp.css';

export default class VerificationPopUp extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showConfirm: false,
            input: "",
            showWarning: this.props.title === 'Terminate Instance'
        }
    }

    completeVerification() {
        this.props.toggle();
    }

    handleClick() {
        this.props.toggle();
    }

    handleConfirm() {
        this.setState({
            showLoading: true
        })

        if (this.state.input === 'confirm') {
            if (this.props.title === "Stop Instance") {
                this.props.verificationAction(this.props.serviceName, this.props.instanceId, this.props.isAdmin, this.props.isTrypi, this.props.region);
                this.props.showLoadAndRefresh()
            } else if (this.props.title === "Abort Scheduled Job") {
                this.props.verificationAction(this.props.jobQueueId)
                return;
            } else if (this.props.title === "Reactivate Instance") {
                this.props.showLoadAndRefresh()
                this.props.verificationAction(this.props.serviceName, this.props.instanceId, this.props.packageId, this.props.region)
            } else if (this.props.title === "Terminate Instance") {
                this.props.showLoadAndRefresh()
                this.props.verificationAction(this.props.serviceName, this.props.instanceId, this.props.region)
            } else {
                this.props.verificationAction(this.props.instanceId);
            }
        }

        this.completeVerification()
    }

    handleInputChange(event, event_tag) {
        event.preventDefault();

        if (event.target.value === "confirm") {
            this.setState({
                input: event.target.value,
                showConfirm: true
            })
        } else {
            this.setState({
                input: event.target.value,
                showConfirm: false
            })
        }
    }

    render() {
        return (
            <div className="try-pi-verification-box">
                <span className="try-pi-verification-title" data-tesid="verification.title">{this.props.title}</span>
                {this.state.showWarning ? <p data-testid="verification.warning">Please be aware that this will permanently stop your instance and data may be lost</p> : <></>}
                <div className="try-pi-verification-form-element">
                    <span className="try-pi-verification-instructions" data-testid="verification.instructions">Type 'confirm' to {this.props.instruction} :<input placeholder={"confirm"} value={this.state.input} onChange={(event) => this.handleInputChange(event, "some stuff")} className="try-pi-verification-input"></input></span>
                </div>
                {this.state.showConfirm ? <button className={"btn-confirm"} data-testid="verification.button.confirm" onClick={() => this.handleConfirm()}>Confirm</button> : <></>}
                <button className={"btn-cancel"} data-testid="verification.button.cancel" onClick={() => this.handleClick()}>Cancel</button>
            </div>
        )
    }
}